import {combineReducers} from 'redux'
import {get, isNil, mapValues} from 'lodash'
import types from 'actions/types'
import {
  mergeWonOpportunities,
  removeFromWonOpportunities,
  sortWonOpportunityList,
  updateWonCounts,
  updateWonOpportunities,
  updateWonValues,
} from 'helpers/opportunities'

export const jobTypes = (state = null, action) => {
  switch (action.type) {
    case types.SALES_UPDATE_WON_FILTERS:
      return get(action, 'filters.jobTypes', state)
    default:
      return state
  }
}

export const company = (state = null, action) => {
  switch (action.type) {
    case types.SALES_UPDATE_WON_FILTERS:
      return get(action, 'filters.company', state)
    default:
      return state
  }
}

export const wonStart = (state = null, action) => {
  switch (action.type) {
    case types.SALES_UPDATE_WON_FILTERS:
      return get(action, 'filters.wonStart', state)
    default:
      return state
  }
}

export const wonEnd = (state = null, action) => {
  switch (action.type) {
    case types.SALES_UPDATE_WON_FILTERS:
      return get(action, 'filters.wonEnd', state)
    default:
      return state
  }
}

export const wonTimeKey = (state = null, action) => {
  switch (action.type) {
    case types.SALES_UPDATE_WON_FILTERS:
      return get(action, 'filters.wonTimeKey', state)
    default:
      return state
  }
}

export const search = (state = '', action) => {
  switch (action.type) {
    case types.SALES_SEARCH_WON_OPPORTUNITIES:
      return action.search
    default:
      return state
  }
}

export const opportunities = (state = {}, action) => {
  switch (action.type) {
    case types.SALES_LOAD_WON_OPPORTUNITIES_ATTEMPT:
      return action.page !== 0
          ? state
          : {
            ...state,
            [action.ownerId]: [],
          }

    case types.SALES_LOAD_WON_OPPORTUNITIES_SUCCESS:
      return action.page > 0
          ? mergeWonOpportunities(state, action.data)
          : {
            ...state,
            [action.ownerId]: sortWonOpportunityList(action.data),
          }

    case types.SALES_UPDATE_WON_OPPORTUNITY:
      return !isNil(action.updatedOpportunity)
          ? updateWonOpportunities(state, action.updatedOpportunity)
          : removeFromWonOpportunities(state, action.previousOpportunity.id)

    default:
      return state
  }
}

export const pages = (state = {}, action) => {
  switch (action.type) {
    case types.SALES_LOAD_ALL_WON_OPPORTUNITIES:
      return mapValues(state, () => 0)

    case types.SALES_LOAD_WON_OPPORTUNITIES_ATTEMPT:
      return {
        ...state,
        [action.ownerId]: isNil(action.page) ? 0 : action.page,
      }

    default:
      return state
  }
}

export const counts = (state = {}, action) => {
  switch (action.type) {

    case types.SALES_LOAD_WON_OPPORTUNITIES_ATTEMPT:
      return action.page > 0
          ? state
          : {
            ...state,
            [action.ownerId]: null,
          }

    case types.SALES_LOAD_WON_OPPORTUNITIES_SUCCESS:
      return isNil(action.count)
          ? state
          : {
            ...state,
            [action.ownerId]: action.count,
          }

    case types.SALES_UPDATE_WON_OPPORTUNITY:
      return updateWonCounts(state, action.previousOpportunity, action.updatedOpportunity)

    default:
      return state
  }
}

export const values = (state = {}, action) => {
  switch (action.type) {

    case types.SALES_LOAD_WON_OPPORTUNITIES_ATTEMPT:
      return action.page > 0
          ? state
          : {
            ...state,
            [action.ownerId]: null,
          }

    case types.SALES_LOAD_WON_OPPORTUNITIES_SUCCESS:
      return isNil(action.value)
          ? state
          : {
            ...state,
            [action.ownerId]: action.value,
          }

    case types.SALES_UPDATE_WON_OPPORTUNITY:
      return updateWonValues(state, action.previousOpportunity, action.updatedOpportunity)

    default:
      return state
  }
}

export const loading = (state = {}, action) => {
  switch (action.type) {

    case types.SALES_LOAD_WON_OPPORTUNITIES_ATTEMPT:
      return {
        ...state,
        [action.ownerId]: true,
      }

    case types.SALES_LOAD_WON_OPPORTUNITIES_SUCCESS:
      return {
        ...state,
        [action.ownerId]: false,
      }

    case types.SALES_LOAD_WON_OPPORTUNITIES_FAILURE:
      return {
        ...state,
        [action.ownerId]: false,
      }

    default:
      return state
  }
}

export default combineReducers({
  opportunities,
  loading,
  pages,
  counts,
  values,
  search,
  jobTypes,
  company,
  wonStart,
  wonEnd,
  wonTimeKey,
})
